module.exports = __webpack_public_path__ + "img/jesse-bodine.bc85146.jpg";